import Highcharts from 'highcharts/highstock';
import { highchartsCrosshairFormatterFromMs } from '../../utils/dateFormatter';

// Configure global Highcharts settings for crosshair labels
// This must be imported by all components that use Highcharts
Highcharts.setOptions({
  // Keep useUTC as true (default) for consistent behavior
  xAxis: {
    crosshair: {
      label: {
        formatter: function(value) {
          // Use our specialized crosshair formatter          
          return highchartsCrosshairFormatterFromMs(value);
        }
      }
    }
  }
});

// Wrapper to remove default crosshair label when using split tooltips
(function(H){
  H.wrap(H.Tooltip.prototype, 'renderSplit', function (proceed) {
    proceed.apply(this, [].slice.call(arguments, 1));
    if (this.tt) {
      this.tt.destroy();
      this.tt = undefined;
    }
  });
}(Highcharts));

export default Highcharts;